module.exports = __webpack_public_path__ + "img/step44_down.e002ff8d.png";